import * as types from '../actiontypes';
import {promiseAreas} from './../../util/uiconstants';

export function createDelegate(url, resource) {
	return {
		type: types.CREATE_DELEGATE,
		meta: {
			api: {
				url,
				method: 'POST',
				data: resource
			}
		}
	};
}
export function deleteDelegate(url) {
	return {
		type: types.DELETE_DELEGATE,
		meta: {
			api: {
				url,
				method: 'DELETE'
				//	trackWithArea: promiseAreas.USER_SETTINGS_AREA
			}
		}
	};
}